<script>
export default {
  name: 'FormStepMixin',
  props: {
    /**
     * Data passed by previous steps of the form
     */
    data: Object,
    /**
     * Function to be called to update the data (callback passed by FormDialog)
     */
    update: Function
  },
  data () {
    return {
      valid: true
    }
  },
  watch: {
    valid (newValue) {
      this.$emit('valid', newValue)
    }
  },
  computed: {
    /**
     *  If true, we are updating something existent
     */
    isUpdate () {
      return !('create' in this.data) || !this.data.create
    },
    /**
     * If true, the form is creating a new element
     */
    isCreate () {
      return !this.isUpdate
    }
  },
  methods: {
    /**
     * Return the form data to be saved when proceeding to next step
     * (components implementing this mixin can overwrite this)
     */
    formData () {
      return {}
    },
    /**
     * Function that will be called when the user arrives on this form step
     * (components implementing this mixin can overwrite this)
     */
    entered () {
    },
    /**
     * Function called to proceed to the next step. Will only proceed if the form is valid
     */
    next () {
      this.valid = this.formIsValid()
      if (this.valid) {
        this.update(this.formData(), true)
      }
    },
    /**
     * Return true if the form is valid
     * First use Vuetify's default form validation
     * If this fails, still allow proceeding if the field that prevents validation has the class 'rules-optional'
     */
    formIsValid () {
      return this.isUpdate ||
        !('form' in this.$refs) ||
        this.$refs.form.validate() ||
        this.$refs.form.inputs
          .filter(input => !input.validate(true))
          .every(input => input.$el.classList.contains('rules-optional'))
    }
  }
}
</script>
